import comp from "./ParentJournal";
export default comp;
